import { Controller } from "@hotwired/stimulus"
import Logger from '../lib/logger'

// Theme Toggle Controller
// Manages light/dark theme switching with localStorage persistence
export default class extends Controller {
  static targets = ["button", "icon"]

  connect() {
    Logger.debug('Theme toggle controller connected')
    // Don't loadTheme() on connect - theme is already set by nonce script
    // Just update icon to match current theme
    const currentTheme = this.getCurrentTheme()
    this.updateIcon(currentTheme)
  }

  // Toggle between light and dark themes
  toggle() {
    const currentTheme = this.getCurrentTheme()
    const newTheme = currentTheme === "dark" ? "light" : "dark"
    
    Logger.debug('Toggling theme', { from: currentTheme, to: newTheme })
    this.setTheme(newTheme)
  }

  // Get current theme from HTML element
  getCurrentTheme() {
    return document.documentElement.getAttribute("data-bs-theme") || "light"
  }

  // Set theme and persist to localStorage
  setTheme(theme) {
    Logger.debug('Setting theme', { theme })
    
    // Update HTML attribute for Bootstrap theme
    document.documentElement.setAttribute("data-bs-theme", theme)
    
    // Save to localStorage
    localStorage.setItem("theme", theme)
    
    // Update icon
    this.updateIcon(theme)
  }

  // Load theme from localStorage or use default
  loadTheme() {
    const savedTheme = localStorage.getItem("theme")
    const systemTheme = window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark"
    const theme = savedTheme || systemTheme
    
    Logger.debug('Loading theme', { 
      theme, 
      savedTheme, 
      systemTheme 
    })
    this.setTheme(theme)
  }

  // Update button icon based on theme
  updateIcon(theme) {
    if (!this.hasIconTarget) return
    
    const icon = this.iconTarget
    
    if (theme === "dark") {
      icon.classList.remove("fa-moon")
      icon.classList.add("fa-sun")
      if (this.hasButtonTarget) {
        this.buttonTarget.title = "Switch to Light Theme"
      }
    } else {
      icon.classList.remove("fa-sun")
      icon.classList.add("fa-moon")
      if (this.hasButtonTarget) {
        this.buttonTarget.title = "Switch to Dark Theme"
      }
    }
  }
}